import { createReducer } from 'redux-act';
import * as actions from 'modules/actions';
import { ILeague, ILeagueCreate } from 'modules/types';

export interface ILeagueUpdateReducerState {
	updated: boolean;
	league: ILeague;
}

export interface ILeagueUpdate extends ILeagueCreate {
	id: number;
}

const initialState: Partial<ILeagueUpdateReducerState> = {
	updated: false
};

export const update_league = createReducer({}, initialState)
	.on(actions.postLeagueUpdateSuccess, (_state, payload) => ({
		...payload
	}));
